import { render } from "./CredentialModal.vue?vue&type=template&id=906e7a0c&scoped=true"
import script from "./CredentialModal.vue?vue&type=script&lang=js"
export * from "./CredentialModal.vue?vue&type=script&lang=js"

import "./CredentialModal.vue?vue&type=style&index=0&id=906e7a0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906e7a0c"]])

export default __exports__